import React from 'react';

import CardHOC from './Components/CardHOC';
import LongText from '../../Types/Components/LongText';

export default function (props) {
  return <CardHOC question={props.question}>
    <LongText {...props} />
  </CardHOC>
}